import { reportTokenDebug } from './errorReporting';

export const isDev = window.location.hostname === 'localhost' && window.location.port === '5173';

export const getDevShotTime = (blockCode?: string, subFolder?: string) => {
  // BLK_001 블록은 8초 간격
  if (blockCode === 'BLK_001') {
    return 8;
  }

  // fellin 블록은 4초
  if (subFolder === 'fellin') {
    return 4;
  }

  // smilegate 블록은 6초
  if (subFolder === 'smilegate') {
    return 6;
  }

  // localhost는 3초, 나머지는 모두 10초
  if (window.location.hostname === 'localhost' && window.location.port === '5173') {
    return 3;
  }

  return 10;
};

const PATHNAMES = [
  '/',
  '/otp',
  '/start',
  '/copy',
  '/payment',
  '/standby',
  '/shot',
  '/chooseframe',
  '/choosephoto',
  '/print',
  '/admin',
];

export const isMainBlock = (pathname: string) => {
  return PATHNAMES.some((p) => p === `/${pathname.split('/')[1]}`);
};

export const getSubFolder = (pathname: string) => {
  return pathname.split('/')[1];
};

export const getTokens = () => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  reportTokenDebug('getTokens 디버그', {
    accessToken: accessToken,
    refreshToken: refreshToken,
    accessTokenType: typeof accessToken,
    refreshTokenType: typeof refreshToken,
    accessTokenLength: accessToken?.length,
    refreshTokenLength: refreshToken?.length,
  });

  return {
    accessToken,
    refreshToken,
  };
};

export const deleteTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const getAccessToken = () => {
  return localStorage.getItem('accessToken');
};

export const getLoginState = () => {
  return localStorage.getItem('isLoggedIn') === 'true';
};
